import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCart } from '~/composables/useCart';
import { useLocalization } from '~/composables/_next/useLocalization';
/**
 * Composable to load Dynamic Yield with Axeptio consent support
 * and full Active Cookie Consent API.
 * @returns DY loader function
 */
export function useDynamicYield() {
  var executeUseHead = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useCart = useCart(),
    cart = _useCart.cart;
  var _useRuntimeConfig = useRuntimeConfig(),
    dyTokenId = _useRuntimeConfig.public.dyTokenId;
  var contextScript = ref('');
  var dyConsentScript = ref('');
  if (executeUseHead) {
    useHead({
      script: [{
        id: 'dy-reco-context',
        innerHTML: contextScript,
        type: 'text/javascript'
      }, {
        id: 'dy-consent-script',
        innerHTML: dyConsentScript,
        type: 'text/javascript'
      }, {
        src: "https://cdn-eu.dynamicyield.com/api/".concat(dyTokenId, "/api_dynamic.js"),
        type: 'text/javascript',
        async: true
      }, {
        src: "https://cdn-eu.dynamicyield.com/api/".concat(dyTokenId, "/api_static.js"),
        type: 'text/javascript',
        async: true
      }]
    });
  }
  /**
   * Format the current locale into Dynamic Yield's expected format.
   * @param currentLocale - The raw locale string (e.g. 'fr', 'en')
   * @returns A formatted locale string for Dynamic Yield (e.g. 'fr_FR', 'en_GB')
   */
  function getFormattedLocale(currentLocale) {
    var _localeMap$currentLoc;
    var localeMap = {
      fr: 'fr_FR',
      es: 'es_ES',
      it: 'it_IT',
      de: 'de_DE',
      en: 'en_GB'
    };
    return (_localeMap$currentLoc = localeMap[currentLocale]) !== null && _localeMap$currentLoc !== void 0 ? _localeMap$currentLoc : 'en_GB';
  }

  /**
   * Normalize the context data for Dynamic Yield based on the type.
   * @param type - The DY context type
   * @param data - Optional context data (string or array)
   * @returns A string array representing the context data
   */
  function getContextData(type, data) {
    if (type === 'HOMEPAGE') {
      return [];
    }
    if (Array.isArray(data)) {
      return data;
    }
    if (typeof data === 'string') {
      return [data];
    }
    return [];
  }

  /**
   * Construct a recommendationContext object for Dynamic Yield.
   * @param type - The recommendation type
   * @param locale - The raw locale string (e.g. 'fr')
   * @param data - Optional context data
   * @returns A formatted context object compatible with Dynamic Yield
   */
  function buildDYContext(type, locale, data) {
    var formattedLocale = getFormattedLocale(locale);
    var contextData = getContextData(type, data);
    return _objectSpread({
      type: type !== null && type !== void 0 ? type : 'OTHER',
      lng: formattedLocale
    }, type !== 'HOMEPAGE' ? {
      data: contextData
    } : {});
  }

  /**
   * Format cart line items from Commercetools into a DY-compatible structure.
   * @param lineItems - Array of line items from the cart
   * @returns An array of cart items formatted for Dynamic Yield
   */
  function formatLineItemsToDYCart(lineItems) {
    return (lineItems !== null && lineItems !== void 0 ? lineItems : []).map(function (item) {
      var _item$variant$sku, _item$variant, _item$quantity, _ref, _item$price$discounte, _item$price, _item$price$discounte2, _item$price$discounte3, _item$price2, _item$price2$value;
      var sku = (_item$variant$sku = item === null || item === void 0 ? void 0 : (_item$variant = item.variant) === null || _item$variant === void 0 ? void 0 : _item$variant.sku) !== null && _item$variant$sku !== void 0 ? _item$variant$sku : '';
      var quantity = (_item$quantity = item === null || item === void 0 ? void 0 : item.quantity) !== null && _item$quantity !== void 0 ? _item$quantity : 0;
      var centAmount = (_ref = (_item$price$discounte = item === null || item === void 0 ? void 0 : (_item$price = item.price) === null || _item$price === void 0 ? void 0 : (_item$price$discounte2 = _item$price.discounted) === null || _item$price$discounte2 === void 0 ? void 0 : (_item$price$discounte3 = _item$price$discounte2.value) === null || _item$price$discounte3 === void 0 ? void 0 : _item$price$discounte3.centAmount) !== null && _item$price$discounte !== void 0 ? _item$price$discounte : item === null || item === void 0 ? void 0 : (_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : (_item$price2$value = _item$price2.value) === null || _item$price2$value === void 0 ? void 0 : _item$price2$value.centAmount) !== null && _ref !== void 0 ? _ref : 0;
      return {
        productId: sku,
        quantity: quantity,
        itemPrice: centAmount / 100
      };
    });
  }

  /**
   * Merge manual and actual cart data, prioritizing data from the formatted cart.
   * @param manualCart - The manually passed cart data
   * @param formattedCart - The cart data formatted from current line items
   * @returns A merged cart array with unique SKUs
   */
  function mergeCartItems() {
    var manualCart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var formattedCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var mergedMap = new Map();
    var _iterator = _createForOfIteratorHelper(manualCart),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _item$productId, _item$quantity2, _item$itemPrice;
        var item = _step.value;
        var sku = (_item$productId = item.productId) !== null && _item$productId !== void 0 ? _item$productId : '';
        if (!sku) continue;
        mergedMap.set(sku, {
          quantity: (_item$quantity2 = item.quantity) !== null && _item$quantity2 !== void 0 ? _item$quantity2 : 0,
          itemPrice: (_item$itemPrice = item.itemPrice) !== null && _item$itemPrice !== void 0 ? _item$itemPrice : 0
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(formattedCart),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _item$productId2, _item$quantity3, _item$itemPrice2;
        var _item = _step2.value;
        var _sku = (_item$productId2 = _item.productId) !== null && _item$productId2 !== void 0 ? _item$productId2 : '';
        if (!_sku) continue;
        mergedMap.set(_sku, {
          quantity: (_item$quantity3 = _item.quantity) !== null && _item$quantity3 !== void 0 ? _item$quantity3 : 0,
          itemPrice: (_item$itemPrice2 = _item.itemPrice) !== null && _item$itemPrice2 !== void 0 ? _item$itemPrice2 : 0
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return Array.from(mergedMap.entries()).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        sku = _ref3[0],
        data = _ref3[1];
      return {
        productId: sku,
        quantity: data.quantity,
        itemPrice: data.itemPrice
      };
    });
  }

  /**
   * Set user opt-out status in Dynamic Yield.
   * This disables consent and removes server-side cookie.
   */
  function setOptOut() {
    var _w$DYO, _w$DYO$ActiveConsent;
    if (!process.client) {
      return;
    }
    var w = window;
    if (w.DY) {
      w.DY.userActiveConsent = {
        accepted: false
      };
    }
    if ((_w$DYO = w.DYO) !== null && _w$DYO !== void 0 && (_w$DYO$ActiveConsent = _w$DYO.ActiveConsent) !== null && _w$DYO$ActiveConsent !== void 0 && _w$DYO$ActiveConsent.updateConsentAcceptedStatus) {
      w.DYO.ActiveConsent.updateConsentAcceptedStatus(false);
    }
  }

  /**
   * Set user opt-in status in Dynamic Yield.
   * This enables consent in the DY environment.
   */
  function setOptIn() {
    var _w$DYO2, _w$DYO2$ActiveConsent;
    if (!process.client) {
      return;
    }
    var w = window;
    if (w.DY) {
      w.DY.userActiveConsent = {
        accepted: true
      };
    }
    if ((_w$DYO2 = w.DYO) !== null && _w$DYO2 !== void 0 && (_w$DYO2$ActiveConsent = _w$DYO2.ActiveConsent) !== null && _w$DYO2$ActiveConsent !== void 0 && _w$DYO2$ActiveConsent.updateConsentAcceptedStatus) {
      w.DYO.ActiveConsent.updateConsentAcceptedStatus(true);
    }
  }

  /**
   * Set the Dynamic Yield recommendation context on the client side.
   * @param type - Recommendation type for DY context
   * @param data - Optional additional data for the context
   */
  function setDynamicYieldContext(type, data) {
    var _window;
    if (!process.client) return;
    var w = (_window = window) !== null && _window !== void 0 ? _window : {};
    if (!(w !== null && w !== void 0 && w.DY)) {
      console.warn('[DY] Dynamic Yield is not available yet');
      return;
    }
    var currentLocale = locale !== null && locale !== void 0 ? locale : 'en';
    var context = buildDYContext(type, currentLocale, data);
    if (context.data || type === 'HOMEPAGE') {
      w.DY.recommendationContext = context;
    }
  }

  /**
   * Track a generic event in Dynamic Yield.
   * Automatically enhances 'Add to Cart' events with current cart data.
   * @param properties - Object containing the event details to send
   */
  function trackDynamicYieldEvent(properties) {
    var _w$DY, _w$DY2;
    if (!process.client) return;
    var w = window;
    if (!(w !== null && w !== void 0 && (_w$DY = w.DY) !== null && _w$DY !== void 0 && _w$DY.API)) {
      console.warn('[DY] API not available to send event:', properties.name);
      return;
    }
    var eventProperties = properties !== null && properties !== void 0 ? properties : {};
    if (properties.name === 'Add to Cart') {
      var _cart$value;
      eventProperties.properties.cart = mergeCartItems(properties.properties.cart, formatLineItemsToDYCart(cart === null || cart === void 0 ? void 0 : (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.lineItems));
      eventProperties.properties.value = properties.properties.value;
    }
    if (!(w !== null && w !== void 0 && (_w$DY2 = w.DY) !== null && _w$DY2 !== void 0 && _w$DY2.API)) {
      console.warn('[DY] API not available to send event:', properties.name);
      return;
    }
    try {
      w.DY.API('event', eventProperties);
    } catch (error) {
      console.warn('[DY] Failed to send event:', properties.name, error);
    }
  }
  /**
   * Check if the user has consented to Dynamic Yield in SSR using rawHeaders.
   * @todo This code causes an error on PLP where the seo metadata are not properly loaded.
   *        It has been disabled for now as we are not using SSR for Dynamic Yield yet.
   *
   * @returns {boolean} True if 'dynamicyield' is listed in the authorized vendors.
   */
  function isDynamicYieldConsentedSSR() {
    // if (!process.server) return false;
    // const event = useRequestEvent();
    // const rawHeaders: string[] = event?.node?.req?.rawHeaders || [];
    // const cookieIndex: number = rawHeaders.findIndex((h) => h.toLowerCase() === 'cookie');
    // if (cookieIndex === -1) {
    //   console.warn('[DY SSR] No cookie header found in rawHeaders');
    //   return false;
    // }
    // const cookieHeader: string = rawHeaders[cookieIndex + 1] || '';
    // const cookies: Record<string, string> = {};
    // cookieHeader.split(';').forEach((c) => {
    //   const [key, ...val] = c.trim().split('=');
    //   try {
    //     const k = decodeURIComponent(key);
    //     const v = val.join('=');
    //     cookies[k] = v;
    //   } catch (_err) {
    //     // skip invalid cookie
    //   }
    // });
    // let rawAuthorized = cookies.axeptio_authorized_vendors || '';
    // try {
    //   rawAuthorized = decodeURIComponent(rawAuthorized);
    // } catch (_err) {
    //   console.warn('[DY SSR] Failed to decode authorised vendors cookie', _err);
    //   rawAuthorized = '';
    // }
    // const vendorsArray = rawAuthorized
    //   .split(',')
    //   .map((v) => v.trim())
    //   .filter((v) => !!v);
    // return vendorsArray.includes('dynamicyield');
    return false;
  }

  /**
   * Inject the Dynamic Yield recommendation context server-side.
   * Handles Axeptio consent based on request headers.
   * @param type - Recommendation context type
   * @param data - Optional context data
   */
  function setDynamicYieldContextSSR(type, data) {
    if (!process.server) return;
    dyConsentScript.value = "\n    window.DY = window.DY || {};\n    window.DY.userActiveConsent = { accepted: ".concat(isDynamicYieldConsentedSSR(), "};\n  ");
    var currentLocale = locale !== null && locale !== void 0 ? locale : 'en';
    var context = buildDYContext(type, currentLocale, data);
    contextScript.value = "\n    window.DY = window.DY || {};\n    window.DY.recommendationContext = ".concat(JSON.stringify(context), ";\n  ");
  }

  /**
   * Format a Dynamic Yield price, ensuring a minimum value of 0.01.
   *
   * @param {number} price - The original price
   * @param {number} discountPrice - The discounted price if available
   * @param {boolean} [inCents=false] - Whether the result should be in cents
   * @param {number} [quantity=1] - Quantity multiplier
   * @returns {number} The formatted price with a minimum of 0.01
   */
  function formatDYprice(price) {
    var discountPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var inCents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var quantity = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var value = discountPrice !== null && discountPrice !== void 0 ? discountPrice : price;
    var formattedPrice = inCents ? Number((value * 100 * quantity).toFixed(2)) : Number((value * quantity).toFixed(2));
    var isInvalid = Number.isNaN(formattedPrice) || formattedPrice <= 0;
    return isInvalid ? 0.01 : formattedPrice;
  }
  return {
    formatDYprice: formatDYprice,
    setDynamicYieldContextSSR: setDynamicYieldContextSSR,
    trackDynamicYieldEvent: trackDynamicYieldEvent,
    setOptOut: setOptOut,
    setOptIn: setOptIn,
    setDynamicYieldContext: setDynamicYieldContext
  };
}